module.exports = __webpack_public_path__ + "static/media/expert.881e7345.svg";